import * as ActionTypes from './../constants';
import { baseUrl, getUserToken } from './index';
// import { AsyncStorage } from 'react-native';
import axios from 'axios';

const dispatchRequestGetCurrentAffairsList = () => ({
    type: ActionTypes.REQUEST_GET_LIST_OF_CURRENT_AFFAIRS_FOR_PAGINATION,
})
const dispatchReceivedGetCurrentAffairsList = res => ({
    type: ActionTypes.RECEIVED_GET_LIST_OF_CURRENT_AFFAIRS_FOR_PAGINATION,
    res
})
export const dispatchClearGetCurrentAffairsListForPagination = () => ({
    type: ActionTypes.CLEAR_GET_LIST_OF_CURRENT_AFFAIRS_FOR_PAGINATION    
})
const dispatchErrorGetCurrentAffairsList = err => ({
    type: ActionTypes.ERROR_GET_LIST_OF_CURRENT_AFFAIRS_FOR_PAGINATION,
    err
})



export const getCurrentAffairsListForPagination = ({after, before}) => async (dispatch) => {
           
    
    const data = {
        afterId: after,
        beforeId: before
    }

    dispatch(dispatchRequestGetCurrentAffairsList(data));
    
    getUserToken()
        .then( authKey => {
            const options = {
                method: 'post',
                url: `${baseUrl}/api/paginate_current_affairs`,                            
                data,           
                headers: {
                    'Authorization': `Bearer ${authKey}`
                }
            }          
            return axios(options)
                .then(({data}) => {    
                    // console.log(data, " current affairs list")              
                    dispatch(dispatchReceivedGetCurrentAffairsList(data))
                })
        })
        .catch(e => dispatch(dispatchErrorGetCurrentAffairsList(e)));    
}